export const getReferralsHasHiddenBubble = (state) =>
  state?.referrals?.hasHiddenBubble

export const getReferralsHasPurchased = (state) =>
  state?.referrals?.hasPurchased
